import styled from "styled-components";
import CardHeader from "../CardHeader/CardHeader";
import Content from "./Content";

const BodyWrapper = styled.div`
  text-align: left;

  .termsofServicesContent {
    max-height: 370px;
    overflow-y: scroll;
  }

  .termsofServicesContent::-webkit-scrollbar {
    width: 5px;
  }

  .termsofServicesContent::-webkit-scrollbar-track {
    background-color: #e2e2e2;
  }

  .termsofServicesContent::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  .section {
    margin-top: 5%;
    margin-right: 1em;
  }

  .headerText {
    font-weight: 500;
    font-size: 20px;
  }

  .content {
    font-size: 15px;
  }
`;

const TermsofServicesContent = () => {
  return (
    <BodyWrapper>
      <CardHeader text={"Terms of Service"} />
      <div className="termsofServicesContent">
        {" "}
        <Content />
      </div>

      {/* <div className="termsofServicesContent">
        <div className="section">
          <p className="content">
            By using this website, you agree to the terms set forth in this
            Terms of Service and in the Privacy Policy.
          </p>
        </div>
        <div className="section">
          <h2 className="headerText">Terms</h2>
        </div>
        <div className="section">
          <p className="content">
            By accessing this Website, you are agreeing to be bound by these
            Website Terms and Conditions of Use and agree that you are
            responsible for the agreement with any applicable local laws. If you
            disagree with any of these terms, you are prohibited from accessing
            this site. The materials contained in this Website are protected by
            copyright and trade mark law.
          </p>
        </div>
        <div className="section">
          <h2 className="headerText">Use</h2>
        </div>
        <div className="section">
          <p className="content">
            Permission is granted to download user generated content on this
            site for the purposes of fair use. This is not a transfer of title,
            and under the use of this site, you may not:
          </p>
        </div>
        <div className="section">
          <p className="content">
            Breaking these rules or doing anything else that we deem unfit for
            use of this service will let us terminate upon violations of any of
            these restrictions. We hold the right to block the access, remove
            the content, or delete the accounts, of anyone, for any reason
            whatsoever. Upon termination, your viewing right will also be
            terminated and you should
          </p>
        </div>
      </div> */}
    </BodyWrapper>
  );
};

export default TermsofServicesContent;
